import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IListMenu } from '@shared/models/interfaces';

@Component({
  selector: 'app-list-menu',
  templateUrl: './list-menu.component.html',
  styleUrls: ['./list-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ListMenuComponent implements OnInit {
  @Input() item: IListMenu;

  constructor(
    private router: Router,
  ) { }

  ngOnInit(): void {
  }

  menuUrl(item: IListMenu) {
    this.router.navigateByUrl(item.menuUrl);
  }

}
